import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { MiscService } from "app/shared/misc.service";
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs";
import { catchError, exhaustMap } from "rxjs/operators";
import * as sharedActions from "./shared.action";

@Injectable({
  providedIn: "root",
})
export class SharedEffects {
  fetchCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sharedActions.fetchCountries),
      exhaustMap((action) =>
        this.miscService.getCountries().pipe(
          exhaustMap((response: any) => [
            sharedActions.fetchCountriesSuccess({ countries: response }),
          ]),
          catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, "An error occured");
            return of(sharedActions.fetchCountriesFailed());
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private toastr: ToastrService,
    private miscService: MiscService
  ) {}
}
